import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleList() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-7xl">
          <div className="mb-10 md:mb-14">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              今日热门大瓜
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600">
              爆料实时更新，不错过任何一个大瓜
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {articles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-300 hover:border-primary-300 cursor-pointer"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Link
                      to={`/category/${article.category}`}
                      className="px-2.5 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {article.categoryName}
                    </Link>
                    {article.isHot && (
                      <span className="px-2 py-0.5 bg-primary-100 text-primary-600 text-xs font-medium rounded-full whitespace-nowrap">
                        热门
                      </span>
                    )}
                  </div>
                  <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
                    {article.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-100">
                    <span className="text-xs text-foreground-500">{article.date}</span>
                    <div className="flex items-center gap-3 text-xs text-foreground-500">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {(article.views / 10000).toFixed(1)}万
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-chat-3-line"></i>
                        {article.comments}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}